import { isEqual } from 'lodash';
import { RiskOverviewFilterItem } from './RiskOverviewFilterModel';

export const RiskOverviewPageSize = 10;

export const getFilteredDiseaseIds = (
  items: RiskOverviewFilterItem[],
  userPreferredDiseaseIds?: number[]
) => {
  const filteredDiseaseIds = items?.filter(x => x.type === 'disease').map(x => x.id);
  return !userPreferredDiseaseIds || filteredDiseaseIds?.length
    ? filteredDiseaseIds
    : userPreferredDiseaseIds;
};
export const getFilteredLocationIds = (
  items: RiskOverviewFilterItem[],
  userPreferredLocationIds?: number[]
) => {
  const filteredLocationIds = items?.filter(x => x.type === 'location').map(x => x.id);
  return !userPreferredLocationIds || filteredLocationIds?.length
    ? filteredLocationIds
    : userPreferredLocationIds;
};

export const toggleFilterItem = (items: RiskOverviewFilterItem[], item: RiskOverviewFilterItem) => {
  return items.some(x => isEqual(x, item))
    ? items.filter(x => !isEqual(x, item))
    : [...items, item];
};
